import {
  CreateJobDescriptionInput,
  UpdateJobDescriptionInput,
} from './job-description.interface';

export class GetJobDescriptions {
  static readonly type = '[JobDescription] get all';
}

export class CreateJobDescription {
  static readonly type = '[JobDescription] create desc';
  constructor(public input: CreateJobDescriptionInput) {}
}
export class GetSingleJobDescription {
  static readonly type = '[JobDescription] get desc';
  constructor(public id: string) {}
}

export class UpdateJobDescription {
  static readonly type = '[JobDescription] update desc';
  constructor(public input: UpdateJobDescriptionInput) {}
}

export class DeleteJobDescription {
  static readonly type = '[JobDescription] delete desc';
  constructor(public id: string) {}
}
